<script setup lang="ts">
import { stringToFaDateTime } from '@payjib/shared'

const props = defineProps({
  lead: { type: Object },
})
</script>

<template>
    <div class="bg-white rounded-xl p-5 lg:p-8 lg:pb-6 relative flex flex-col-reverse lg:flex-col gap-6 lg:gap-0">
        <div class="flex flex-col gap-6">
            <!-- Header -->
            <div class="flex flex-col lg:flex-row items-center justify-center gap-2 lg:justify-start">
                <div
                    class="w-full lg:w-fit flex items-center justify-center text-[13px]  h-10 rounded-[10px] px-6 bg-[#eaeef5] text-[#2d5396]">
                    کد لید:
                    <span class="font-fa ms-1">{{ lead?.id }}</span>
                </div>

            </div>
            <!-- Body -->
            <div class="flex flex-col gap-2.5 text-[13px]">
                <div class="flex items-center gap-1">
                    <span>نام و نام خانوادگی:</span>

                    <span class="">{{ lead?.full_name }}</span>
                </div>
                <div class="flex items-center gap-1">
                    <span>شماره موبایل:</span>
                    <span dir="ltr" class="font-fa">{{ lead?.phone }}</span>
                </div>
            </div>
            <!-- Footer -->
            <div
                class="flex flex-col lg:flex-row lg:items-center justify-end gap-6 mt-2 lg:mt-4 lg:gap-0  pe-1 text-[13px]">
                <div class="flex flex-wrap items-center justify-between lg:justify-end gap-4 mb-2">
                    <div class="flex items-center">
                        ثبت:<span dir="ltr" class="ms-1 font-fa">{{ stringToFaDateTime(lead?.created_at) }}</span>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
